import React, { Component } from 'react';
import axios from "axios";
import InputMask from 'react-input-mask';

import api from '../../../api/';

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';


import Detail from "./Detail.js"
import EnviarMail from "./EnviarMail.js"
import EnviarMailUVT from "./EnviarMailUVT.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import Enums from "../EstadoEnum.js"

import dateFunctions from '../../functions/dateFunctions';

class EnvioDeEmails extends Component {
    handleAccesorDescargado(data){
        let descargado = 'NO';
        const fecha_descarga = data.fecha_descarga; // Puede venir nulo/undefined desde la api

        switch (true) {
            case fecha_descarga === null:
                descargado = "NO";
                break;
            case fecha_descarga === undefined:
                descargado = "NO";
                break;
            case fecha_descarga === "":
                descargado = "NO";
                break;
            case fecha_descarga.trim() === "":
                descargado = "NO";
                break;
            default:
                descargado = dateFunctions.parseDate(fecha_descarga);
        }

        return descargado
    }

    constructor() {
        super();
        this.state = {
            startDate: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "cantEtapas",
                    id: "cantEtapas",
                    accessor: "cantEtapas",
                    show: false,
                    private:true,
                },
                {
                    Header: "Etapa",
                    id: "numeroEtapa",
                    width: 50,
                    accessor: (d)=> (d.numeroEtapa && d.cantEtapas) ? ((d.cantEtapas!=0) ? (d.numeroEtapa + '/' + d.cantEtapas) : ('-')) : ('-'),
                    show: true,
                    className: "text-center",
                },
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fechamail",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechamail),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />

                },
                {
                    Header: "Título",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa_nombre",
                    accessor: d => d.empresa_nombre,
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                },
                {
                    Header: "Link",
                    id: "link",
                    width: 100,
                    className: "text-center",
                    accessor: d => (d.link ? <a target="_blank" href={api.informes + d.link}>LINK INFORME</a> : ""),
                    filterable: false,
                    show: true,
                },
                {
                    Header: "Descargado",
                    id: "fecha_descarga",
                    width: 170,
                    className: "text-center",
                    accessor: this.handleAccesorDescargado,
                    filterable: false,
                    show: true,
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    width: 200,
                    show: true,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            className="w-100"
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="EMAIL PENDIENTE DE ENVIO">EMAIL PENDIENTE DE ENVIO</option>
                            <option value="EMAIL ENVIADO">EMAIL ENVIADO</option>
                        </select>,
                    accessor: d => {
                        if (d.strestado == "EMAIL PENDIENTE DE ENVIO")
                            return <div className="badge badge-warning">{d.strestado}</div>;
                        else if (d.strestado == "EMAIL ENVIADO")
                            return <div className="badge badge-success">{d.strestado}</div>;
                        else
                            return <div className="badge badge-primary">{d.strestado}</div>;
                    },
                },
                {
                    Header: "id",
                    id: "fechaMailPedidoFactura",
                    accessor: "fechaMailPedidoFactura",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Solicitud Factura",
                    id: "estadoSolicitudFactura",
                    width: 200,
                    show: true,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            className="w-100"
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="PENDIENTE">PENDIENTE</option>
                            <option value="SOLICITADA">SOLICITADA</option>
                        </select>,
                    accessor: d => {
                        if (d.estadoSolicitudFactura == "PENDIENTE")
                            return (<div className="badge badge-warning presupuestoStateLabel">PENDIENTE
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechamail)}</small>
                            </div>);
                        else
                            return <div className="badge badge-success presupuestoStateLabel">{"SOLICITADA"} <br></br> <small>{dateFunctions.parseDateTime(d.fechaMailPedidoFactura)}</small></div >;
                    },
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        permission: 'sendemail_send',
                        component: EnviarMail,
                    },
                    {
                        edit: true,
                        permission: 'sendemail_senduvt',
                        component: EnviarMailUVT,
                    },
                ]}

                apiUrl={api.proyectos.enviodemails.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.enviodemails.export}
                title={"Envío de Informe al Cliente"}
            />
        );
    }
}

export default EnvioDeEmails;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento6/EnvioDeEmails.js